import { useEffect } from 'react';
import { useSettings } from '../contexts/SettingsContext';

/**
 * Custom hook to manage page title with site name
 * Ensures title updates immediately when component mounts
 * @param {string} pageTitle - The page-specific title (e.g., "Kampanyalar", "İletişim")
 */
export const usePageTitle = (pageTitle) => {
  const { settings } = useSettings();

  useEffect(() => {
    const fullTitle = pageTitle 
      ? `${pageTitle} - ${settings.site_name || 'Cinefora'}`
      : settings.site_name || 'Cinefora';
    
    document.title = fullTitle;
  }, [pageTitle, settings.site_name]);
};
